export default "__VITE_ASSET__NjrNg8NE__"